import Vue from "vue";
import myComponents from "../../components";
import {
  Upload,
  Image,
  Radio,
  RadioGroup,
  Rate,
  Dialog,
  Loading,
  Message,
  Tooltip,
  Input,
  Select,
  Option,
  Popover,
  Row,
  Col,
  Form,
  Button,
  Tabs,
  TabPane,
  FormItem,
  Popconfirm,
  Drawer
} from "element-ui";

const components = {
  ...myComponents,
  Upload,
  Image,
  Rate,
  RadioGroup,
  Radio,
  Dialog,
  Tooltip,
  Input,
  Option,
  Popover,
  Row,
  Col,
  Select,
  Form,
  Button,
  FormItem,
  Popconfirm,
  Viewer,
  Tabs,
  TabPane,
  Drawer
};
import Viewer from "v-viewer/src/component.vue";
Viewer.name = "Viewer";
Object.keys(components).forEach(name => {
  Vue.component(components[name].name, components[name]);
});

Vue.use(Loading.directive);
Vue.prototype.$message = Message;
